/*!
 * Floating Labels
 */
var $ = require('jquery');

$(function() {
	var formFloatingLabel = function () {
		var FL_onClass = "on",
				FL_showClass = "show";

		$("input, textarea")
			.bind("checkval", function() {
				var label = $(this).prev("label");
				if (this.value !== "") {
					label.addClass(FL_showClass);
				} else {
					label.removeClass(FL_showClass);
				}
			})
			.on("keyup", function() {
				$(this).trigger("checkval");
			})
			.on("focus", function() {
				$(this).prev("label").addClass(FL_onClass);
			})
			.on("blur", function() {
				$(this).prev("label").removeClass(FL_onClass);
			})
			.trigger("checkval");

		$("select")
			.bind("checkval", function() {
				var label = $(this).prev("label");
				if (this.value !== "") {
					label.addClass(FL_showClass);
				} else {
					label.removeClass(FL_showClass);
				}
			})
			.on("change", function() {
				$(this).trigger("checkval");
			})
			.trigger("checkval");
		$("[type=datetime-local]")
			.bind("checkval", function() {
				var label = $(this).prev("label");
				label.addClass(FL_showClass);
			})
			.trigger("checkval");
	}

	formFloatingLabel();

	$(document).on('afterContentsReplaced', function () {
		formFloatingLabel();
	})

});



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/formFloatingLabels.js